import { ABPopupMessageLayout } from "../../../common/lookups/Layouts/ABLayouts";
import { IDCodesLookupLayout, IDTradingPartnerLookupLayout} from "../../../common/lookups/Layouts/IdLayouts"

const AdditionalLayout = [
    {
        groupId: 1,
        label: "",
        fields: [
            {
                name: "CarrierSTATUS",
                localizedField: "STATUS",
                tableName: "IDCARRIER",
                label: "STATUS",
                type: "select",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CarrierSCACCODE",
                localizedField: "SCACCODE",
                tableName: "IDCARRIER",
                label: "SCACCODE",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CarrierPOPUPMESSAGE",
                localizedField: "POPUPMESSAGE",
                tableName: "IDCARRIER",
                label: "POPUPMESSAGE",
                type: "lookup",
                "layout":ABPopupMessageLayout({ tableName: 'IDCARRIER' }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CarrierR_TRADINGPARTNER",
                localizedField: "R_TRADINGPARTNER",
                tableName: "IDCARRIER",
                label: "R_TRADINGPARTNER",
                type: "lookup",
                layout: IDTradingPartnerLookupLayout({ type: 'none' }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CarrierINTEGRATIONEXPORTTYPE",
                localizedField: "INTEGRATIONEXPORTTYPE",
                tableName: "IDCARRIER",
                label: "INTEGRATIONEXPORTTYPE",
                type: "select",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
        ]
    },
    {
        groupId: 2,
        label: "Insurance",
        fields: [
            {
                name: "CarrierINSURANCEAMOUNT",
                localizedField: "INSURANCEAMOUNT",
                tableName: "IDCARRIER",
                label: "INSURANCEAMOUNT",
                type: "number",
                format: "$#,###0.00",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CarrierINSURANCEEXPIRATION",
                localizedField: "INSURANCEEXPIRATION",
                tableName: "IDCARRIER",
                label: "INSURANCEEXPIRATION",
                type: "date",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
        ]
    }
];

const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CarrierUSERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IDCARRIER",
                "label": "Code 1",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C3' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IDCARRIER",
                "label": "Code 2",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C4' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IDCARRIER",
                "label": "Code 3",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C5' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IDCARRIER",
                "label": "Code 4",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C6' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IDCARRIER",
                "label": "Code 5",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IDCARRIER",
                "label": "Code 6",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IDCARRIER",
                "label": "Code 7",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'C9' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IDCARRIER",
                "label": "Code 8",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'D0' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IDCARRIER",
                "label": "Code 9",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'D1' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "CarrierUSERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IDCARRIER",
                "label": "Code 10",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'D2' }),
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CarrierUSERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IDCARRIER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IDCARRIER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IDCARRIER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IDCARRIER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IDCARRIER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IDCARRIER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IDCARRIER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IDCARRIER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IDCARRIER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IDCARRIER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CarrierUSERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IDCARRIER",
                "label": "Quantity 1",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IDCARRIER",
                "label": "Quantity 2",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IDCARRIER",
                "label": "Quantity 3",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IDCARRIER",
                "label": "Quantity 4",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IDCARRIER",
                "label": "Quantity 5",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IDCARRIER",
                "label": "Quantity 6",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IDCARRIER",
                "label": "Quantity 7",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IDCARRIER",
                "label": "Quantity 8",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IDCARRIER",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IDCARRIER",
                "label": "Quantity 10",
                "type": "number", 
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const ReferencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CarrierUSERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IDCARRIER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IDCARRIER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IDCARRIER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IDCARRIER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IDCARRIER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IDCARRIER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IDCARRIER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IDCARRIER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IDCARRIER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CarrierUSERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IDCARRIER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CarrierUSERDEFINEDCOMMENT",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "idCustomer",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]

const WMDefaultsLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CarrierSHOWONWMWEB",
                "tableName": "IDCARRIER",
                "localizationedField": "SHOWONWMWEB",
                "label": "Show-WM Web",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const OMDefaultsLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CarrierFREIGHTRATE",
                "localizedField": "FREIGHTRATE",
                "tableName": "IDCARRIER",
                "label": "Freight Rate",
                "type": "number",
                'format': "$#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]

export {
    AdditionalLayout,
    CodesLayout,
    ReferencesLayout,
    WMDefaultsLayout,
    OMDefaultsLayout
}